import React, { useEffect } from "react";
import Lottie from "lottie-react";
import celebrationAnimation from "../animations/celebration.json";
import logo from "../images/macrolifelogo3.png";
import { useNavigate } from "react-router-dom";

const CongratulationPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo({
      top:0,
      left:0,
      behavior:"instant"
    })
    const timer = setTimeout(() => {
      navigate("/");
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="w-full h-screen flex flex-col items-center justify-center bg-white">
      {/* Logo */}
      <img src={logo} alt="Logo" className="w-[150px] h-[150px] mt-4 mb-[-63px]" />

      {/* Celebration Animation */}
      <div className="w-full sm:w-4/5 md:w-3/4 lg:w-2/3 xl:w-1/2 h-auto flex items-center justify-center">
        <Lottie animationData={celebrationAnimation} loop autoplay className="w-full h-full" />
      </div>
    </div>
  );
};

export default CongratulationPage;
